import * as axios from '../../utilities/axios'
import addIdToQuotes from '../../utilities/addIdToQuotes'
import { attachMetaCapiContext } from '../../utilities/metaCapiContext'

export const shouldAllowCreate = ticketIDs => {
  return axios.basic
    .post(`api/v1/utility/allowCreationTrafficTicket/`, {
      ticketIDs
    })
    .then(res => res.data)
    .catch(axios.parseError)
}

export const movingViolations = (state) => {
  return axios.basic
    .get(`api/v1/traffic/movingViolations/state/${state}`)
    .then(res => res.data.results)
    .catch(axios.parseError)
}

export const saveOutOfArea = (email, state) => {
  return axios.basic
    .post(`api/v1/utility/outOfArea/`, {
      email,
      state
    })
    .then(res => res.data)
    .catch(axios.parseError)
}

export const get = (objectId, sessionToken) => {
  return axios
    .secure(sessionToken)
    .get(`${process.env.PARSE_DIR}/classes/TrafficTicket/${objectId}`)
    .then(res => res.data)
    .catch(axios.parseError)
}

export const getAll = (sessionToken) => {
  return axios
    .secure(sessionToken)
    .get(`/api/v1/trafficticket/query/all`)
    .then(res => res.data.results)
    .catch(axios.parseError)
}


export const create = (dataObject, sessionToken) => {
  if (!dataObject.telemetry) {
    dataObject.telemetry = {
      origin_create: 'v2 web app',
      created_source: 'regular_flow',
    }
  }
  return axios
    .secure(sessionToken)
    .post(`api/v1/trafficticket/create/`, attachMetaCapiContext(dataObject))
    .then(res => res.data)
    .catch(axios.parseError)
}

export const update = (objectId, dataObject, sessionToken) => {
  return axios
    .secure(sessionToken)
    .put(`api/v1/trafficticket/update/${objectId}`, dataObject)
    .then(res => res.data)
    .catch(axios.parseError)
}

export const getQuotes = (ticket, sessionToken) => {
  return axios
    .secure(sessionToken)
    .post(`api/v1/attorney/quotesForTrafficTicket`, {
      trafficTicketIdentifier: ticket.objectId
    })
    .then(res => addIdToQuotes(res.data, ticket.ticketID))
    .catch(axios.parseError)
}

export const getFetcherTickets = (ticketInfo, sessionToken) => {
  return axios
    .secure(sessionToken)
    .post(`api/v1/fetcher`, ticketInfo)
    .then(res => res.data)
    .catch(axios.parseError)
}

export const getFetcherTicketsBySearchCriteriaId = (fetcherSearchCriteriaId, sessionToken) => {
  return axios
    .secure(sessionToken)
    .get(`api/v1/fetcher/${fetcherSearchCriteriaId}`)
    .then(res => res.data)
    .catch(axios.parseError)
}

export const addImageToTicket = (
  imagePointer,
  ticketObjectId,
  sessionToken
) => {
  const data = {
    ticketImage: {
      ...imagePointer,
      __type: 'File'
    }
  }
  return axios
    .secure(sessionToken)
    .put(
      `${process.env.PARSE_DIR}/classes/TrafficTicket/${ticketObjectId}`,
      data
    )
    .then(res => res.data)
    .catch(axios.parseError)
}

export const createEvidenceImageEntry = (
  imagePointer,
  ticketObjectId,
  userObjectId,
  sessionToken
) => {
  const data = {
    file: {
      ...imagePointer,
      __type: 'File'
    },
    ticket: {
      __type: 'Pointer',
      className: 'TrafficTicket',
      objectId: ticketObjectId
    },
    user: {
      __type: 'Pointer',
      className: '_User',
      objectId: userObjectId
    }
  }

  return axios
    .secure(sessionToken)
    .post(`${process.env.PARSE_DIR}/classes/WITrafficEvidence`, data)
    .then(res => res.data)
    .catch(axios.parseError)
}

export const getTicketEvidenceImages = (ticketObjectId, sessionToken) => {
  return axios
    .secure(sessionToken)
    .get(
      `${process.env.PARSE_DIR}/classes/WITrafficEvidence?where={"ticket":{"__type":"Pointer","className":"TrafficTicket","objectId":"${ticketObjectId}"}}`
    )
    .then(res => {
      if (!res || !res.data || !res.data.results || !res.data.results.length) {
        return []
      }
      return res.data.results
        .filter(result => {
          if (!result || !result.file || !result.file.url) {
            return false
          }
          return true
        })
        .map(result => ({ url: result.file.url, name: result.file.name }))
    })
    .catch(axios.parseError)
}

export const getCaseProtectionEligible = (ticketObjectId, sessionToken) => {
  return axios
    .secure(sessionToken)
    .get(`api/v1/trafficticket/caseProtection/eligible/${ticketObjectId}`)
    .then(res => res.data)
    .catch(axios.parseError)
}

export const getUserDOTTicketsAndQuotes = (sessionToken) => {
  return axios
    .secure(sessionToken)
    .get(`api/v1/trafficticket/dot/ticketsByUser`)
    .then(res => res.data)
    .catch(axios.parseError)
}

export const getFinancingPlanDetails = (financingPlanId, sessionToken) => {
  return axios
      .secure(sessionToken)
      .get(`api/v1/trafficticket_financing_plan/getDetails/${financingPlanId}`)
      .then(res => res.data)
      .catch(axios.parseError)
}

export const unsubscribeDOTUser = (sessionToken) => {
  return axios
    .secure(sessionToken)
    .put(`api/v1/trafficticket/dot/unsubscribe`)
    .then(res => res.data)
    .catch(axios.parseError)
}

export const createTrafficTicketFromDOTTicket = (dataObject, sessionToken) => {
  if (!dataObject.telemetry) {
    dataObject.telemetry = {
      origin_create: 'v2 web app DOT',
      created_source: 'regular_flow',
      lookup_page: 'dot',
    }
  }
  return axios
    .secure(sessionToken)
    .post(`api/v1/trafficticket/dot/create`, attachMetaCapiContext(dataObject))
    .then(res => res.data)
    .catch(axios.parseError)
}

export const createTrafficTicketFromSearchResult = (dataObject, sessionToken) => {
  if (!dataObject.telemetry) {
    dataObject.telemetry = {
      origin_create: 'v2 web app',
      created_source: 'regular_flow',
      lookup_page: 'traffic-lookup',
    }
  }
  return axios
      .secure(sessionToken)
      .post(`api/v1/trafficticket/create/fromSearchResultForMe`, attachMetaCapiContext(dataObject))
      .then(res => res.data)
      .catch(axios.parseError)
}

export const createTrafficTicketFromOneStepCheckout = (dataObject) => {
  if (!dataObject.telemetry) {
    dataObject.telemetry = {
      origin_create: 'v2 web app - linkGenerator',
      created_source: 'regular_flow',
      lookup_page: 'one-step-checkout',
    }
  }
  return axios.basic
      .post(`api/v1/trafficticket_onestepcheckout/create`, attachMetaCapiContext(dataObject))
      .then(res => res.data)
      .catch(axios.parseError)
}
